import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const QuestionsAnswers = () => {
  const [openFaq, setOpenFaq] = useState(null);
  const { t } = useTranslation('common');
  const faqs = (t('faq.items', { returnObjects: true }) || []).map((f, idx) => ({ id: idx + 1, ...f }));

  const toggleFaq = (id) => {
    setOpenFaq(openFaq === id ? null : id);
  };

  return (
    <section className="bg-[#fff9ed] py-16 lg:py-24">
      <div className="container mx-auto px-8 lg:px-16">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-start">
          {/* Left Side - Content */}
          <div>
            <p className="text-base font-semibold text-text-dark mb-2">{t('faq.kicker')}</p>
            <h2 className="text-4xl lg:text-5xl font-bold text-text-dark mb-6">
              {t('faq.title1')}<br />
              {t('faq.title2')}
            </h2>
            
            <p className="text-base text-text-dark leading-relaxed mb-8">
              {t('faq.body')}
            </p>
            
            <Link to="../contact" className="bg-brown hover:bg-brown-dark text-cream px-8 py-3 rounded text-sm font-normal uppercase tracking-wide transition-all duration-300 hover:-translate-y-1 hover:shadow-lg">
              {t('cta.contactUs')}
            </Link>
          </div>

          {/* Right Side - FAQ List */}
          <div className="space-y-4">
            {faqs.map((faq) => (
              <div 
                key={faq.id} 
                className="border-b-2 border-brown pb-4 cursor-pointer group hover:border-brown transition-colors duration-300"
              >
                <div 
                  className="flex items-center justify-between"
                  onClick={() => toggleFaq(faq.id)}
                >
                  <p className="text-base text-text-dark group-hover:text-brown transition-colors duration-300">{faq.question}</p>
                  <svg 
                    className={`w-5 h-5 text-text-dark group-hover:text-brown transition-all duration-300 ${
                      openFaq === faq.id ? 'rotate-90' : ''
                    }`}
                    fill="none" 
                    stroke="currentColor" 
                    viewBox="0 0 24 24"
                  >
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                  </svg>
                </div>
                
                {/* Answer Section with Slide Animation */}
                <div 
                  className={`overflow-hidden transition-all duration-500 ease-in-out ${
                    openFaq === faq.id ? 'max-h-96 opacity-100 mt-4' : 'max-h-0 opacity-0'
                  }`}
                >
                  <p className="text-sm text-text-dark leading-relaxed">{faq.answer}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default QuestionsAnswers;
